//Request style
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
}

//BaseUrl
axios.defaults.baseURL = AJAX_BASE

/*
 * Axios error handler
 */
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    return Promise.reject(error)
})

// Add a request interceptor
if(ActiveCalculation && ActiveCalculation.read_only) {
    axios.defaults.headers.common['Ec-Read-Only'] = ActiveCalculation.read_only_code
}